import React, { useRef, useState } from 'react';
import ClickAwayListener from 'react-click-away-listener';
import { Popup } from '@progress/kendo-react-popup';
import { Button } from '@ui';
import { translate } from '@utils/i18n';
import CompleteReviewModal from '../CompleteReviewModal';
const namespace = 'features.ai_to_review_inspections.index.actions';
function ActionButtons({ inspection }) {
    const [open, setOpen] = useState(false);
    const [showCompleteModal, setShowCompleteModal] = useState(false);
    const anchor = useRef(null);
    const handleClose = () => {
        setOpen(false);
    };
    const handleStartReview = () => {
        // Open inspection in IIM tab
        const inspectionUrl = `/inspections/${encodeURIComponent(inspection.inspectionId)}#iim-issues`;
        window.open(inspectionUrl, '_blank', 'noopener,noreferrer');
        handleClose();
    };
    const handleSendForCorrection = () => {
        const inspectionUrl = `/inspections/${encodeURIComponent(inspection.inspectionId)}?openSendForCorrection=true#iim-issues`;
        window.open(inspectionUrl, '_blank', 'noopener,noreferrer');
        handleClose();
    };
    const handleCompleteReview = () => {
        setShowCompleteModal(true);
        handleClose();
    };
    const handleCloseCompleteModal = () => {
        setShowCompleteModal(false);
    };
    return (React.createElement("div", { className: "action-buttons" },
        React.createElement(Button, { ref: anchor, variant: "default", onClick: () => setOpen(!open), className: "action-menu-button" },
            React.createElement("i", { className: "fa-light fa-ellipsis" })),
        React.createElement(Popup, { anchor: anchor.current, show: open, onClose: handleClose },
            React.createElement(ClickAwayListener, { onClickAway: handleClose },
                React.createElement("div", { className: "qmb-popup--action-list" },
                    React.createElement("ul", { role: "presentation" },
                        React.createElement("li", { role: "presentation" },
                            React.createElement(Button, { variant: "default", onClick: handleStartReview, className: "action-menu-item" },
                                React.createElement("i", { className: "fa-light fa-search" }),
                                translate('start_review', { namespace }))),
                        React.createElement("li", { role: "presentation" },
                            React.createElement(Button, { variant: "default", onClick: handleSendForCorrection, className: "action-menu-item" },
                                React.createElement("i", { className: "fa-light fa-arrow-rotate-left" }),
                                translate('send_for_correction', { namespace }))),
                        React.createElement("li", { role: "presentation" },
                            React.createElement(Button, { variant: "default", onClick: handleCompleteReview, className: "action-menu-item" },
                                React.createElement("i", { className: "fa-light fa-check" }),
                                translate('complete_review_process', { namespace }))))))),
        React.createElement(CompleteReviewModal, { isOpen: showCompleteModal, inspectionId: inspection.inspectionId, currentStatus: inspection.inspectionStatus, onClose: handleCloseCompleteModal })));
}
export default ActionButtons;
